import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@mpt-fo/common/core/services/authentication.service';
import { TimelineModel } from '@mpt-fo/common/shared/models/timeline.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';
import { CustomInput, PasswordInput, PasswordValidatorType } from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { DEFAULT_MODAL_KAMONA_CLASSES, DEFAULT_MODAL_WIDTH, MONIEPOINT_DESIGN_TYPE } from '@mpt-fo/common/shared/constants';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LivelinessErrorCode } from '@mpt-fo/common/core/services/liveliness.service';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
	@Input() step: TimelineModel;
	@Input() stepsArray: TimelineModel[];
	@Output() back: EventEmitter<any> = new EventEmitter();
	@Output() continue: EventEmitter<any> = new EventEmitter();
	activationToken = '';
	usernameValue = '';
	username: CustomInput;
	passwordInput: PasswordInput;
	showSuccess: boolean;
	loading = true;
	form: FormGroup;
	submittingForm: boolean;
	runningModal: NzModalRef;
	isDisableButton: boolean;

	constructor(
		private fb: FormBuilder,
		private auth: AuthenticationService,
		private activatedRoute: ActivatedRoute,
		private localStorage: LocalStorageService,
		private mobileService: MobileWebViewService,
		private router: Router,
		private modalService: ModalService
	) {}

	ngOnInit(): void {
		this.localStorage.deleteAll();
		this.form?.reset();
		this.username = new CustomInput(null, 'Username', true);
		this.passwordInput = new PasswordInput(null, 'Password', true, PasswordValidatorType.CUSTOM);
		this.form = this.fb.group({
			username: this.username.getFormGroupControl(),
			password: this.passwordInput.getFormGroupControl(),
			validationKey: [null, [Validators.required]],
		});
		this.activatedRoute.queryParams.subscribe((params) => {
			this.usernameValue = decodeURIComponent(params.username);
			this.activationToken = decodeURIComponent(params.token);
			this.form.patchValue({
				username: this.usernameValue,
				validationKey: this.activationToken,
				password: null,
			});
		});
		if (this.mobileService.isMobileWebViewUser()) {
			this.mobileService.setChangePasswordCredential({
				username: this.usernameValue,
				validationKey: this.activationToken,
				password: null,
			});
			this.router.navigateByUrl(`/mobile/change-password`);
		}
		this.loading = false;
	}

	next() {
		if (!this.form?.valid) {
			return;
		}
		this.submittingForm = true;
		const body = this.buildObj();
		this.auth
			.changePassword(body)
			.then((res) => {
				this.showSuccess = true;
				this.submittingForm = false;
			})
			.catch((err) => {
				const restartProcess = err?.error?.responseCode === LivelinessErrorCode.LIVELINESS_REFERENCE_CONSUMED;
				const description = StringHelper.getErrorMessageHttpErrorResponse(err);
				this.launchAlertModal({
					description,
					callbackName: restartProcess ? 'Restart' : 'Close',
					callback: () => {
						this.closeModal();
						if (restartProcess) {
							this.router.navigateByUrl('/password-reset');
						}
					}
				});
				this.submittingForm = false;
			});
	}

	launchAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'error';
		config.nzComponentParams.title = 'Request failed';
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		config.nzComponentParams.callback = params?.callback;
		this.runningModal = this.modalService.alert(config);
	}

	closeModal() {
		this.runningModal?.destroy();
	}

	buildObj() {
		return this.form.value;
	}

	setPassword($event: PasswordInput) {
		this.passwordInput = $event;
		this.isDisableButton = $event.validate();
	}
}
